export const COURSE_HEADER_HEIGHT = 56
